import React from 'react'
import { connect } from 'react-redux'
import { last } from 'lodash'
import { withStyles, Hidden } from '@material-ui/core'
import { DndEditor } from 'components/TemplateForm/Desktop'
import SMS from './SMS'
import Group from './Group'
import Typography from '@material-ui/core/Typography'
import styles from '../styles'
import language from 'utils/vast-languagepack'
import TaskInfo from '../MobileForm/TaskInfo'
import Snippets from '../MobileForm/Snippets'
import ReassignContact from './ReassignContact'
import RemoveContactFromCampaign from './RemoveContactFromCampaign'
import HttpSendData from './HttpSendData'
import NeedsFollowUp from './NeedsFollowUp'

const AddOrEditTaskPage_Preview_index = ({
  emailCardSelected,
  selectedAction,
  classes,
  bottomNavigation,
  disabled,
  stats,
  campaignStatus,
  automationTypeSelected,
  modal,
}) => {
  const disabledTypography = disabled ? (
    <Typography
      className={
        disabled ? classes.emailHeaderTextError : classes.emailHeaderText
      }
      variant="body1"
    >{`This task ${
      stats && automationTypeSelected !== 'stage' ? 'has been triggered' : ''
    }${stats && campaignStatus ? ' and' : ''} ${
      campaignStatus
        ? `is part of a ${
            campaignStatus === 'C' ? 'completed' : 'live'
          } campaign`
        : ''
    } and cannot be edited.`}</Typography>
  ) : null

  const preview = () => {
    if (selectedAction === 'sms') {
      return (
        <div>
          {disabledTypography}
          <SMS taskForm />
        </div>
      )
    } else if (selectedAction === 'email' && emailCardSelected === 'blank') {
      return (
        <div style={{ position: 'relative' }}>
          {disabledTypography}
          <div className={classes.emailScroll}>
            <DndEditor modal={modal} />
          </div>
        </div>
      )
    } else if (selectedAction === 'email') {
      return null
    } else if (selectedAction?.slice(0, 5) === 'group') {
      return (
        <>
          {disabledTypography}
          <Group />
        </>
      )
    } else if (selectedAction === 'reassignContact') {
      return (
        <>
          {disabledTypography}
          <ReassignContact />
        </>
      )
    } else if (selectedAction === 'removeContactFromCampaign') {
      return (
        <>
          {disabledTypography}
          <RemoveContactFromCampaign />
        </>
      )
    } else if (selectedAction === 'httpSendData') {
      return (
        <>
          {disabledTypography}
          <HttpSendData />
        </>
      )
    } else if (selectedAction?.slice(-13) === 'NeedsFollowUp') {
      return (
        <>
          {disabledTypography}
          <NeedsFollowUp />
        </>
      )
    } else {
      return (
        <div style={{ color: '#444', paddingTop: '12px' }}>
          <Typography variant="h2" gutterBottom>
            {language.task.add.createANewTask}
          </Typography>
          <p>
            {language.task.add.taskTypeSelect}{' '}
            <strong>{language.task.add.taskTypeSelect2}</strong>{' '}
            <Hidden smDown>{language.task.add.taskTypeSelect3}</Hidden>
            <Hidden mdUp>
              or start typing a description and watch the magic happen.
            </Hidden>
          </p>
        </div>
      )
    }
  }

  const display = [preview(), <TaskInfo />, <Snippets />]

  return (
    <>
      <Hidden smDown>{preview()}</Hidden>
      <Hidden mdUp>{display[bottomNavigation] || preview()}</Hidden>
    </>
  )
}

export default connect(state => {
  const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
  const stats = task?.sms_stats || task?.email_stats
  const campaignStatus =
    state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
  const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
  const disabled = Boolean(
    (stats && automationTypeSelected !== 'stage') ||
      campaignStatus === 'L' ||
      campaignStatus === 'C',
  )

  return {
    emailCardSelected: last(state.email.cardSelected),
    selectedAction: state.tasks.addOrEdit.fields.selectedActionPrediction.value,
    bottomNavigation: state.tasks.addOrEdit.bottomNavigation.index,
    disabled,
    stats,
    campaignStatus,
    automationTypeSelected,
  }
}, null)(withStyles(styles)(AddOrEditTaskPage_Preview_index))
